import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import { Users } from 'lucide-react';
import { LeadSourceData } from '@/hooks/useAnalytics';

interface LeadSourceChartProps {
  data: LeadSourceData[];
}

const chartConfig = {
  count: {
    label: 'Leads',
    color: 'hsl(var(--primary))',
  },
};

export function LeadSourceChart({ data }: LeadSourceChartProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          Lead Sources
        </CardTitle>
        <CardDescription>
          Distribution of leads by acquisition source
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="horizontal">
              <XAxis 
                type="number"
                tick={{ fontSize: 12 }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis 
                type="category"
                dataKey="source" 
                tick={{ fontSize: 12 }}
                axisLine={false}
                tickLine={false}
                width={80}
              />
              <ChartTooltip 
                content={<ChartTooltipContent 
                  formatter={(value, name) => [value, 'Leads']}
                  labelFormatter={(label) => `Source: ${label}`}
                />}
              />
              <Bar 
                dataKey="count" 
                fill="var(--color-count)" 
                radius={[0, 4, 4, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
        <div className="mt-4 space-y-2">
          {data.map((item) => (
            <div key={item.source} className="flex justify-between text-sm">
              <span className="text-muted-foreground">{item.source}</span>
              <span className="font-medium">{item.count} leads ({item.percentage}%)</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}